module.exports = __webpack_public_path__ + "img/flowergirl.4ee69cb5.png";